module.exports = __webpack_public_path__ + "img/carpet_one.8859af10.png";